import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=d2bfcd1e&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=d2bfcd1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bfcd1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2bfcd1e')) {
      api.createRecord('d2bfcd1e', component.options)
    } else {
      api.reload('d2bfcd1e', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=d2bfcd1e&scoped=true&", function () {
      api.rerender('d2bfcd1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/blindOpen/widget.vue"
export default component.exports